import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EErrorNotificationType } from '../../types/notifications';
import { EErrorNotificationActionType } from './types';

export const pushErrorNotification = actionGenerator<EErrorNotificationActionType.Pushed, EErrorNotificationType>(
  EErrorNotificationActionType.Pushed,
);
